import React, { useState, useEffect, useRef, useCallback } from 'react';

// ── Asset imports ──────────────────────────────────────────────────────────────
import truuna       from '../../assets/agriculture/truuna.png';
import dms          from '../../assets/agriculture/dms.png';
import suru         from '../../assets/agriculture/suru.png';
import suru1        from '../../assets/agriculture/suru1.png';
import servingsmall from '../../assets/hospitility/servingsmall.png';
import serving      from '../../assets/hospitility/serving.png';
import lifting      from '../../assets/industrial/lifting.png';
import magicmirror  from '../../assets/toys/magicmirror.png';

// ── Popup imports ─────────────────────────────────────────────────────────────
import ProductsPopup from '../../webpopup/ProductsPopup';
import ProdImgPopup  from '../../webpopup/ProdImgPopup';

// ══════════════════════════════════════════════════════════════════════════════
// PRODUCT DATA (unchanged)
// ══════════════════════════════════════════════════════════════════════════════

const categories = [
  {
    name: 'Agriculture & Farming',
    emoji: '🌾',
    categoryKey: 'agriculture',
    products: [
      {
        name: 'TRUUNA',
        productKey: 'truuna',
        productType: 'Outdoor Product',
        image: truuna,
        tagline: 'Autonomous Natural-Farming Assistant',
        description:
          'Tractive Robotic Unmanned Universal Natural-farming Assistant — An advanced autonomous farming solution designed to revolutionize agricultural practices with precision navigation, intelligent crop management, and sustainable farming techniques for modern agriculture.',
        specifications: {
          'Size': '1830 x 1500 x 1340 mm',
          'Adjustable Speed': '3km/h to 15km/h',
          'Operational Range': 'Approximately 6 hrs per charge',
          'Drive System': '4W Electric Motors (24 V)',
          'Charging': 'AC power, 6-8 hours',
          'Battery': '300 AmpH',
          'Pay Load Capacity': 'Up to 150 kg',
          'Laser Type': 'Blue Fiber Laser',
          'Laser Capacity': '80 watts',
        },
      },
      {
        name: 'AMRRITA',
        productKey: 'dms',
        productType: 'Software Product',
        image: dms,
        tagline: 'Advanced Milk Retail & Inventory System',
        description:
          'Advanced Milk Retail Real-time Inventory Transaction Application — A comprehensive digital management system for milk collection, processing, and distribution operations, enabling real-time tracking, quality control, and seamless transaction management for dairy businesses.',
        specifications: {
          'Platform': 'Web & Mobile (iOS/Android)',
          'Database': 'Cloud-based real-time synchronization',
          'Analytics': 'Advanced reporting & insights',
          'Integration': 'Payment gateway, SMS, email',
          'Users': 'Unlimited concurrent users',
          'Quality Monitoring': 'Automated fat, SNF detection',
          'Billing': 'Automated invoice generation',
          'Security': 'End-to-end encryption',
        },
      },
      {
        name: 'SURU15',
        productKey: 'suru',
        productType: 'Indoor Product',
        image: suru,
        tagline: 'Automated Barn Cleaning Robotic Unit',
        description:
          'शेण उचलणारा रोबोटिक युनिट — An automated waste management robotic unit engineered for efficient barn cleaning and livestock facility maintenance, featuring intelligent navigation and high-capacity waste collection capabilities for modern farming operations.',
        specifications: {
          'Collection Capacity': '200 liters waste storage',
          'Cleaning Width': '1.2 meters coverage',
          'Speed': '0.5-1.5 m/s adjustable',
          'Navigation': 'Autonomous path planning',
          'Power': 'Rechargeable lithium battery',
          'Runtime': '6-8 hours per charge',
          'Sensors': 'Obstacle detection, level sensors',
          'Material': 'Food-grade stainless steel',
        },
      },
      {
        name: 'Scrapping Robot',
        productKey: 'suru1',
        productType: 'Outdoor Product',
        image: suru1,
        tagline: 'Next-Generation Cleaning Solution',
        description:
          'Cleaning Up for a Greener Future — Next-generation automated cleaning solution with enhanced mobility, increased capacity, and advanced sensors for optimal performance in diverse agricultural environments and livestock management facilities.',
        specifications: {
          'Collection Capacity': '300 liters waste storage',
          'Cleaning Width': '1.5 meters coverage',
          'Speed': '0.5-2.0 m/s variable',
          'Navigation': 'AI-powered adaptive routing',
          'Power': 'High-capacity Li-ion battery',
          'Runtime': '10-12 hours per charge',
          'Sensors': 'Advanced obstacle avoidance, AI vision',
          'Durability': 'Heavy-duty industrial grade',
        },
      },
    ],
  },
  {
    name: 'Hospitality Robots',
    emoji: '🏨',
    categoryKey: 'hospitility',
    products: [
      {
        name: 'SEVA (सेवा)',
        productKey: 'servingsmall',
        productType: 'Indoor Product',
        image: servingsmall,
        tagline: 'Serving Every Visitor Affectionately',
        description:
          'Serving Every Visitor Affectionately — An intelligent service robot designed to deliver exceptional hospitality experiences with precision navigation, interactive features, and autonomous serving capabilities for restaurants, hotels, and event venues.',
        specifications: {
          'Carrying Capacity': '40 kg total load',
          'Tray Count': '3-4 serving trays',
          'Speed': 'Up to 1.2 m/s',
          'Navigation': 'SLAM-based autonomous',
          'Display': '10-inch touchscreen interface',
          'Voice': 'Multi-language voice interaction',
          'Battery': '8-10 hours operation',
          'Safety': 'Emergency stop, collision avoidance',
        },
      },
      {
        name: 'GaDaI (गडी)',
        productKey: 'serving',
        productType: 'Indoor Product',
        image: serving,
        tagline: 'Guided Automated Delivery System',
        description:
          'Guided Automated Delivery Assistance to Individuals — An advanced delivery robot system providing efficient and reliable service in hospitality environments, featuring obstacle avoidance, multi-floor navigation, and secure compartment storage for seamless guest service.',
        specifications: {
          'Compartments': '4 secure storage units',
          'Load Capacity': '50 kg maximum',
          'Speed': 'Up to 1.5 m/s',
          'Navigation': 'Multi-floor elevator integration',
          'Security': 'PIN/RFID access control',
          'Battery': '12 hours continuous operation',
          'Communication': 'App-based tracking & notifications',
          'Dimensions': '600mm x 500mm x 1200mm',
        },
      },
    ],
  },
  {
    name: 'Industrial Products',
    emoji: '🏭',
    categoryKey: 'industrial',
    products: [
      {
        name: 'GAADV',
        productKey: 'lifting',
        productType: 'Outdoor Product',
        image: lifting,
        tagline: 'Goods Autonomous Adaptive Delivery Vehicle',
        description:
          'Goods Autonomous Adaptive Delivery Vehicle — A robust industrial robot designed for material handling, heavy lifting, and automated logistics in manufacturing facilities, featuring adaptive load management, intelligent path planning, and integration with existing warehouse systems.',
        specifications: {
          'Load Capacity': '500 kg maximum payload',
          'Lifting Height': 'Up to 2 meters',
          'Speed': '0.5-2.5 m/s adjustable',
          'Navigation': 'Laser-guided AGV system',
          'Power': 'Industrial-grade battery pack',
          'Runtime': '16 hours continuous operation',
          'Integration': 'WMS, ERP system compatible',
          'Safety': 'Multiple safety sensors, emergency stop',
        },
      },
    ],
  },
  {
    name: 'Toys & Entertainment',
    emoji: '🎮',
    categoryKey: 'toys',
    products: [
      {
        name: 'Magic Mirror',
        productKey: 'magicmirror',
        productType: 'Indoor Product',
        image: magicmirror,
        tagline: 'Augmented Reality Interactive Experience',
        description:
          "Magic of Mirror — An interactive smart mirror technology combining augmented reality, facial recognition, and AI to create engaging educational and entertainment experiences, perfect for children's learning, interactive games, and immersive storytelling.",
        specifications: {
          'Display': '32-inch Full HD touchscreen',
          'Technology': 'AR + AI + Facial Recognition',
          'Camera': '1080p HD camera',
          'Content': '100+ educational games & activities',
          'Age Range': '3-12 years',
          'Languages': 'Multi-language support',
          'Connectivity': 'Wi-Fi, Bluetooth',
          'Parental Controls': 'App-based monitoring & limits',
        },
      },
    ],
  },
];

// Flat list for all products
const allProducts = categories.flatMap((cat) =>
  cat.products.map((p) => ({
    ...p,
    categoryKey: cat.categoryKey,
    categoryName: cat.name,
    categoryEmoji: cat.emoji,
  }))
);

// ══════════════════════════════════════════════════════════════════════════════
// UTILITY — Extract long-form product name from description
// ══════════════════════════════════════════════════════════════════════════════

function extractLongFormName(description) {
  if (!description) return '';
  const emDashIdx = description.indexOf(' — ');
  if (emDashIdx !== -1) return description.slice(0, emDashIdx).trim();
  const hyphenIdx = description.indexOf(' - ');
  if (hyphenIdx !== -1) return description.slice(0, hyphenIdx).trim();
  return description.trim();
}

// ══════════════════════════════════════════════════════════════════════════════
// ANIMATION UTILITIES (unchanged)
// ══════════════════════════════════════════════════════════════════════════════

function lerp(a, b, t) { return a + (b - a) * t; }
function clamp(value, min, max) { return Math.min(Math.max(value, min), max); }
function mapRange(value, inMin, inMax, outMin, outMax) {
  const t = clamp((value - inMin) / (inMax - inMin), 0, 1);
  return lerp(outMin, outMax, t);
}
function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
function easeInOutQuart(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
}

// ══════════════════════════════════════════════════════════════════════════════
// CINEMATIC SCROLL HOOK — now responsive (adjusts ranges for mobile)
// ══════════════════════════════════════════════════════════════════════════════

function useCinematicScroll(sectionRef, imageRef, textRef, accentRef, badgeRef) {
  const lerpedProgress = useRef(0);
  const rawProgress    = useRef(0);
  const rafId          = useRef(null);
  const isVisible      = useRef(false);
  const isMobile       = useRef(false);

  // Detect mobile screen size
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e) => { isMobile.current = e.matches; };
    isMobile.current = mq.matches;
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        isVisible.current = entry.isIntersecting;
        if (entry.isIntersecting) {
          el.classList.add('cs--visible');
          if (!rafId.current) rafId.current = requestAnimationFrame(tick);
        } else {
          if (rafId.current) {
            cancelAnimationFrame(rafId.current);
            rafId.current = null;
          }
        }
      },
      { threshold: 0, rootMargin: '10% 0px 10% 0px' }
    );
    io.observe(el);

    function tick() {
      if (!isVisible.current) {
        rafId.current = null;
        return;
      }

      const section = sectionRef.current;
      if (!section) {
        rafId.current = requestAnimationFrame(tick);
        return;
      }

      const rect = section.getBoundingClientRect();
      const vh   = window.innerHeight;
      const slideCenter = rect.top + rect.height * 0.5;
      const raw = clamp(1 - slideCenter / vh, 0, 1);
      rawProgress.current = raw;

      // Lerp factor (slightly higher on mobile for snappier feel)
      const lerpFactor = isMobile.current ? 0.1 : 0.06;
      lerpedProgress.current = lerp(lerpedProgress.current, rawProgress.current, lerpFactor);
      const p = lerpedProgress.current;

      // ── Layer 1: Background image scaler ─────────────────────────────────
      if (imageRef.current) {
        const scaleMin = 1.0;
        const scaleMax = isMobile.current ? 1.03 : 1.07;
        const scaleFactor = mapRange(p, 0, 1, scaleMin, scaleMax);

        const driftMin = 0;
        const driftMax = isMobile.current ? -5 : -14;
        const driftX = mapRange(p, 0.3, 0.8, driftMin, driftMax);

        imageRef.current.style.transform =
          `scale(${scaleFactor.toFixed(4)}) translateX(${driftX.toFixed(2)}px)`;
      }

      // ── Layer 2: Text panel ─────────────────────────────────────────────
      if (textRef.current) {
        const enterProgress = easeOutCubic(mapRange(p, 0, 0.45, 0, 1));
        const exitProgress  = easeInOutQuart(mapRange(p, 0.55, 1, 0, 1));

        const enterY = isMobile.current ? 10 : 20;
        const exitY  = isMobile.current ? -16 : -32;
        const translateY = lerp(enterY, 0, enterProgress) + lerp(0, exitY, exitProgress);

        const opacityEnter = mapRange(p, 0, 0.3, 0.3, 1);
        const opacityExit  = mapRange(p, 0.75, 1, 1, 0.15);
        const opacity      = Math.min(opacityEnter, opacityExit);

        textRef.current.style.transform = `translateY(${translateY.toFixed(2)}px)`;
        textRef.current.style.opacity   = opacity.toFixed(3);
      }

      // ── Layer 3: Accent overlay breath ──────────────────────────────────
      if (accentRef.current) {
        const overlayOpacity = mapRange(Math.abs(p - 0.5), 0, 0.5, 1.0, 0.2);
        accentRef.current.style.opacity = overlayOpacity.toFixed(3);
      }

      // ── Layer 4: Category badge micro‑parallax ──────────────────────────
      if (badgeRef.current && !isMobile.current) {  // disable on mobile for cleaner UI
        const badgeDrift = mapRange(p, 0, 1, -6, 6);
        badgeRef.current.style.transform = `translateY(${badgeDrift.toFixed(2)}px)`;
      }

      rafId.current = requestAnimationFrame(tick);
    }

    rafId.current = requestAnimationFrame(tick);

    return () => {
      io.disconnect();
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
        rafId.current = null;
      }
    };
  }, []);
}

// ══════════════════════════════════════════════════════════════════════════════
// DOT NAVIGATION (hidden on mobile via CSS)
// ══════════════════════════════════════════════════════════════════════════════

function DotNav({ total, activeIndex, onDotClick }) {
  return (
    <nav className="dotnav" aria-label="Product navigation">
      {Array.from({ length: total }, (_, i) => (
        <button
          key={i}
          className={`dotnav__dot${i === activeIndex ? ' dotnav__dot--active' : ''}`}
          onClick={() => onDotClick(i)}
          aria-label={`Go to product ${i + 1}`}
          aria-current={i === activeIndex ? 'true' : undefined}
        />
      ))}
    </nav>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// CINEMATIC SLIDE (used on all screen sizes)
// ══════════════════════════════════════════════════════════════════════════════

const CinematicSlide = React.memo(function CinematicSlide({
  product,
  index,
  totalCount,
  onSpecsClick,
  onGalleryClick,
}) {
  const sectionRef = useRef(null);
  const imageRef   = useRef(null);
  const textRef    = useRef(null);
  const accentRef  = useRef(null);
  const badgeRef   = useRef(null);

  useCinematicScroll(sectionRef, imageRef, textRef, accentRef, badgeRef);

  const longFormName = extractLongFormName(product.description);
  const panelSide = 'cs__panel--right'; // keep class for potential styling

  const handleSpecs = useCallback(
    (e) => { e.stopPropagation(); onSpecsClick(product); },
    [product, onSpecsClick]
  );

  const handleGallery = useCallback(
    (e) => { e.stopPropagation(); onGalleryClick(product); },
    [product, onGalleryClick]
  );

  return (
    <section
      ref={sectionRef}
      className={`cs cs--${index}`}
      data-index={index}
      aria-label={product.name}
    >
      {/* Image area — purely visual */}
      <div className="cs__bg-wrap" aria-hidden="true">
        <div ref={imageRef} className="cs__img-scaler">
          <img
            src={product.image}
            alt=""
            className="cs__bg-img"
            loading={index < 2 ? 'eager' : 'lazy'}
            draggable={false}
          />
        </div>
        <div ref={accentRef} className="cs__accent-overlay" aria-hidden />
      </div>

      {/* Content overlay */}
      <div className="cs__overlay">
        {/* Category badge */}
        <div ref={badgeRef} className="cs__category-badge">
          <span className="cs__category-emoji">{product.categoryEmoji}</span>
          <span className="cs__category-label">{product.categoryName}</span>
        </div>

        {/* Counter (top‑right) */}
        <div className="cs__counter" aria-label={`Product ${index + 1} of ${totalCount}`}>
          <span className="cs__counter-current">{String(index + 1).padStart(2, '0')}</span>
          <span className="cs__counter-sep"> / </span>
          <span className="cs__counter-total">{String(totalCount).padStart(2, '0')}</span>
        </div>

        {/* Text panel */}
        <div ref={textRef} className={`cs__panel ${panelSide}`}>
          <p className="cs__product-type">{product.productType}</p>
          <h2 className="cs__product-name">{product.name}</h2>
          <p className="cs__tagline">{product.tagline}</p>
          <p className="cs__longform-name">{longFormName}</p>

          <div className="cs__actions">
            <button
              className="cs__btn cs__btn--primary"
              onClick={handleSpecs}
              aria-label={`View specifications for ${product.name}`}
            >
              <span>View Specifications</span>
              <span className="cs__btn-arrow" aria-hidden>→</span>
            </button>
            <button
              className="cs__btn cs__btn--ghost"
              onClick={handleGallery}
              aria-label={`Open ${product.name} image gallery`}
            >
              <span>Gallery</span>
            </button>
          </div>
        </div>

        {/* Scroll cue — first slide only */}
        {index === 0 && (
          <div className="cs__scroll-cue" aria-hidden>
            <div className="cs__scroll-line" />
            <span className="cs__scroll-text">Scroll to explore</span>
          </div>
        )}
      </div>
    </section>
  );
});

// ══════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ══════════════════════════════════════════════════════════════════════════════

function Products() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [specsProduct, setSpecsProduct] = useState(null);
  const [galleryProduct, setGalleryProduct] = useState(null);

  // Track active slide for dot navigation (desktop only, but we keep state)
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.index);
            if (!isNaN(idx)) setActiveIndex(idx);
          }
        });
      },
      { threshold: 0.5 }
    );

    const slides = document.querySelectorAll('.cs');
    slides.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const handleDotClick = useCallback((idx) => {
    document.querySelector(`.cs--${idx}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  const handleSpecsClick = useCallback((product) => setSpecsProduct(product), []);
  const handleGalleryClick = useCallback((product) => setGalleryProduct(product), []);

  return (
    <>
      <div className="cinematic-products">
        {/* Header */}
        <header className="cp-header">
          <h1 className="cp-header__title">📦 Our Products</h1>
          <p className="cp-header__subtitle">
            Innovative robotics and automation solutions across multiple industries
          </p>
        </header>

        {/* Dot navigation (hidden on mobile via CSS) */}
        <DotNav
          total={allProducts.length}
          activeIndex={activeIndex}
          onDotClick={handleDotClick}
        />

        {/* Slides */}
        {allProducts.map((product, idx) => (
          <CinematicSlide
            key={`${product.categoryKey}__${product.productKey}`}
            product={product}
            index={idx}
            totalCount={allProducts.length}
            onSpecsClick={handleSpecsClick}
            onGalleryClick={handleGalleryClick}
          />
        ))}
      </div>

      {/* Popups */}
      {specsProduct && (
        <ProductsPopup
          product={specsProduct}
          onClose={() => setSpecsProduct(null)}
        />
      )}

      {galleryProduct && (
        <ProdImgPopup
          productName={galleryProduct.name}
          category={galleryProduct.categoryKey}
          productKey={galleryProduct.productKey}
          onClose={() => setGalleryProduct(null)}
        />
      )}
    </>
  );
}

export default Products;